module.exports = __webpack_public_path__ + "img/successfully_done.2327dc46.svg";